export default function toBoolean(value) {
    if(value.toLowerCase() === 'true') return true;
    return false;
}